import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-massive-deliveries-bread-crumb',
  templateUrl: './deliveries-bread-crumb.component.html',
  styleUrls: ['./deliveries-bread-crumb.component.sass'],
})
export class DeliveriesBreadCrumbComponent {
  @Input() title: string;
  @Input() items: string[];

  constructor(private router: Router) {}

  goBack(): void {
    this.router.navigate(['masivos/new-routing']);
  }
}
